import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from './BottomNav';
import WorkerCard from './WorkerCard';
import './Auth.css';

const workers = [
  {
    name: 'Amit Sharma',
    location: 'Varikoli',
    price: 700,
    rating: 4.5,
    works: 127,
    months: 5,
    skills: ['welding', 'cutting', 'roofing'],
    reviews: [
      { name: 'Surendran', date: '10/09/2024', text: 'Amit Sharma exceeded my expectations. His roofing works are beyond spectacular.' },
      { name: 'Satheeshan', date: '02/09/2024', text: 'Amit Sharma worked pretty well. He is dedicated in his work. The welding and cutting of my new gate was almost perfect.' }
    ],
    oldPrice: 900,
    newPrice: 855,
    avatar: 'https://ui-avatars.com/api/?name=Amit+Sharma&background=0074a6&color=fff&size=64',
  },
  {
    name: 'Rahul Singh',
    location: 'Kochi',
    price: 1200,
    rating: 4.8,
    works: 210,
    months: 8,
    skills: ['cleaning', 'cooking'],
    reviews: [],
    oldPrice: 1500,
    newPrice: 1200,
    avatar: 'https://ui-avatars.com/api/?name=Rahul+Singh&background=0090d0&color=fff&size=64',
  },
  {
    name: 'Vikram Yadav',
    location: 'Thrissur',
    price: 950,
    rating: 4.2,
    works: 98,
    months: 3,
    skills: ['painting', 'plumbing'],
    reviews: [],
    oldPrice: 1100,
    newPrice: 950,
    avatar: 'https://ui-avatars.com/api/?name=Vikram+Yadav&background=00b4d8&color=fff&size=64',
  },
  {
    name: 'Sandeep Verma',
    location: 'Alappuzha',
    price: 800,
    rating: 4.7,
    works: 180,
    months: 6,
    skills: ['gardening', 'babysitting'],
    reviews: [],
    oldPrice: 1000,
    newPrice: 800,
    avatar: 'https://ui-avatars.com/api/?name=Sandeep+Verma&background=ffb300&color=fff&size=64',
  },
];

// Helper to calculate discount
const getDiscount = (oldPrice, newPrice) => {
  if (!oldPrice || !newPrice || oldPrice <= newPrice) return null;
  const percent = Math.round(((oldPrice - newPrice) / oldPrice) * 100);
  return percent > 0 ? `${percent}% OFF` : null;
};

const bannerImages = [
  'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=400&q=80',
  'https://images.unsplash.com/photo-1465101178521-c1a9136a3b99?auto=format&fit=crop&w=400&q=80'
];

const Home = () => {
  const navigate = useNavigate();
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [locationName, setLocationName] = useState(() => sessionStorage.getItem('userLocationName') || 'Kothamangalam');
  const [bannerIndex, setBannerIndex] = useState(0);
  const bannerRef = useRef();

  useEffect(() => {
    if (!localStorage.getItem('locationPermissionAsked')) {
      setShowLocationModal(true);
    }
    // Add exit confirmation popup
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleAllowLocation = () => {
    setShowLocationModal(false);
    localStorage.setItem('locationPermissionAsked', 'true');
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (pos) => {
        const { latitude, longitude } = pos.coords;
        try {
          const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
          const data = await res.json();
          const city = data.address.city || data.address.town || data.address.village || data.address.state || 'Your Location';
          setLocationName(city);
          sessionStorage.setItem('userLocationName', city);
        } catch {
          setLocationName('Your Location');
          sessionStorage.setItem('userLocationName', 'Your Location');
        }
      }, () => {
        setLocationName('Your Location');
        sessionStorage.setItem('userLocationName', 'Your Location');
      });
    } else {
      setLocationName('Your Location');
      sessionStorage.setItem('userLocationName', 'Your Location');
    }
  };
  const handleDenyLocation = () => {
    setShowLocationModal(false);
    localStorage.setItem('locationPermissionAsked', 'true');
    setLocationName('Kothamangalam');
    sessionStorage.setItem('userLocationName', 'Kothamangalam');
  };

  const handleWorkerClick = (worker) => {
    navigate('/profile', { state: worker });
  };

  // Banner scroll handler
  const handleBannerScroll = () => {
    if (!bannerRef.current) return;
    const scrollLeft = bannerRef.current.scrollLeft;
    const width = bannerRef.current.offsetWidth;
    const idx = Math.round(scrollLeft / width);
    setBannerIndex(idx);
  };

  return (
    <div className="home-bg">
      {showLocationModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{maxWidth: 320, textAlign: 'center'}}>
            <div style={{fontWeight: 600, fontSize: 17, marginBottom: 16}}>Enable Location?</div>
            <div style={{fontSize: 15, marginBottom: 18}}>To show services near you, please allow access to your phone's location.</div>
            <div style={{display: 'flex', gap: 12, justifyContent: 'center'}}>
              <button className="auth-btn" style={{flex: 1}} onClick={handleAllowLocation}>Allow</button>
              <button className="auth-btn" style={{background: '#eee', color: '#0074a6', flex: 1}} onClick={handleDenyLocation}>Deny</button>
            </div>
          </div>
        </div>
      )}
      <div className="home-header" style={{boxShadow: '0 4px 24px rgba(0,116,166,0.10)', borderRadius: '0 0 32px 32px', padding: '32px 0 32px 0', background: 'linear-gradient(135deg, #0090d0 80%, #00b4d8 100%)', marginBottom: 32}}>
        <div className="home-location-row" style={{padding: '0 24px', alignItems: 'center', gap: 14}}>
          <span className="home-location-icon" style={{background: '#fff', color: '#0090d0', width: 44, height: 44, fontSize: 28, boxShadow: '0 2px 8px rgba(0,0,0,0.07)'}}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="8" r="5" fill="#0090d0"/><path d="M4 20c0-2.21 3.58-4 8-4s8 1.79 8 4" stroke="#0090d0" strokeWidth="2" strokeLinecap="round"/></svg>
          </span>
          <div>
            <div className="home-location-label" style={{color: '#e0f2ff', fontSize: 15, fontWeight: 500}}>Current Location</div>
            <div className="home-location-value" style={{color: '#fff', fontWeight: 800, fontSize: 22, letterSpacing: 0.5}}>{locationName}</div>
          </div>
        </div>
        <div className="search-bar-container" style={{marginTop: 24, marginBottom: 0, maxWidth: 95 + '%', padding: '0 16px'}}>
          <span className="search-bar-icon">
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="7" />
              <line x1="16.5" y1="16.5" x2="21" y2="21" />
            </svg>
          </span>
          <input className="search-bar-input" type="text" placeholder="Search for services, workers..." />
        </div>
      </div>
      <div className="home-section">
        <div className="home-section-title">Top Workers</div>
        <div className="home-workers-row">
          {workers.slice(0, 2).map((w, i) => (
            <WorkerCard key={i} worker={{...w, discount: getDiscount(w.oldPrice, w.newPrice)}} onClick={() => handleWorkerClick(w)} />
          ))}
        </div>
      </div>
      <div className="home-section">
        <div className="home-section-title">Explore</div>
        <div className="home-explore-carousel" ref={bannerRef} onScroll={handleBannerScroll}>
          {bannerImages.map((src, idx) => (
            <div className="home-explore-banner" key={idx}>
              <img src={src} alt={`explore-banner-${idx+1}`} className="home-explore-img" onError={e => e.target.src='https://via.placeholder.com/300x100?text=Explore'} />
            </div>
          ))}
        </div>
        <div className="home-explore-indicators">
          {bannerImages.map((_, idx) => (
            <span key={idx} className={"home-explore-dot" + (bannerIndex === idx ? " active" : "")}></span>
          ))}
        </div>
      </div>
      <div className="home-section">
        <div className="home-section-title">Hiring History</div>
        <div className="home-workers-row">
          {workers.slice(2, 4).map((w, i) => (
            <WorkerCard key={i} worker={{...w, discount: getDiscount(w.oldPrice, w.newPrice)}} onClick={() => handleWorkerClick(w)} />
          ))}
        </div>
      </div>
      <div className="home-section">
        <div className="home-section-title">Rooms</div>
        <div className="home-rooms-card">
          <img src="https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80" alt="rooms" className="home-rooms-img" onError={e => e.target.src='https://via.placeholder.com/300x80?text=Rooms'} />
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default Home; 